import { render } from "./HeroSectionInvestor.vue?vue&type=template&id=610f346d&scoped=true"
import script from "./HeroSectionInvestor.vue?vue&type=script&lang=js"
export * from "./HeroSectionInvestor.vue?vue&type=script&lang=js"

import "./HeroSectionInvestor.vue?vue&type=style&index=0&id=610f346d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f346d"]])

export default __exports__